import always from "ramda/es/always";
import compose from "ramda/es/compose";
import curry from "ramda/es/curry";
import forEach from "ramda/es/forEach";
import ifElse from "ramda/es/ifElse";
import is from "ramda/es/is";
import map from "ramda/es/map";
import when from "ramda/es/when";
import isFunction from "ramda-extension/es/isFunction";
import isNotNil from "ramda-extension/es/isNotNil";
import { batchActions } from 'redux-batched-actions';
export const callActionsWithArgs = curry((dispatch, runInBatch, action, args)=>{
    const resolveAction = when(isFunction, (actionFn)=>actionFn(...args));
    const callNextAction = compose(dispatch, resolveAction);
    const runBatch = compose(dispatch, batchActions, map(resolveAction));
    const runSequence = forEach(callNextAction);
    const batchOrSequence = ifElse(always(runInBatch), runBatch, runSequence);
    when(isNotNil, ifElse(is(Array), batchOrSequence, callNextAction))(action);
});
